import { render, staticRenderFns } from "./systemAdmin.vue?vue&type=template&id=54153f34"
import script from "./systemAdmin.vue?vue&type=script&lang=js"
export * from "./systemAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports